'use strict';

module.exports = ['$scope', '$timeout', 'MembershipSvc', 'ModalSvc', 'InvitationSvc', 'toastr', function ($scope, $timeout, MembershipSvc, ModalSvc, InvitationSvc, toastr) {
    // ------------------
    // scope functions
    // ------------------
    $scope.addCustomer = function (form) {

        var modalInstance = ModalSvc.inviteUser.open({
            plant: $scope.plantObj,
            organization: $scope.plantObj.business,
            roleName: "Customer",
            title: "Add Customer"
        });

        modalInstance.result.then(function (data) {
            toastr.success('The invitation has been sent to the customer.');
            fetchData();
        });
    };

    $scope.removeMembership = function (membership) {
        MembershipSvc.delete(membership, $scope.plant).then(function () {
            fetchData();
        });
    };

    $scope.removeInvitation = function (invitation) {
        InvitationSvc.delete(invitation, $scope.plant).then(function () {
            fetchData();
        });
    };

    // ------------------
    // Watches
    // ------------------

    // ------------------
    // Helper functions
    // ------------------

    // ------------------
    // Fetch Data
    // ------------------
    function fetchData() {
        MembershipSvc.list_customers($scope.$root.plant).success((data) => {
            $scope.customers = data;
        });

        InvitationSvc.list_plant_pending($scope.$root.plant, {"include_roles": "customer"}).success((data) => {
            data.forEach(function (item) {
                item.date_invited = moment(item.date_invited).format($scope.$root.dateFormat.moment);
            });
            $scope.pending_invitations = data;
        });
    }

    fetchData();
    // ------------------
    // Initialization
    // ------------------
    $scope.customers = [];
}];